import { render, staticRenderFns } from "./planAddOrUpdate.vue?vue&type=template&id=3735d0ec&scoped=true"
import script from "./planAddOrUpdate.vue?vue&type=script&lang=js"
export * from "./planAddOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./planAddOrUpdate.vue?vue&type=style&index=0&id=3735d0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735d0ec",
  null
  
)

export default component.exports